import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

interface UseSessionStorageReturnNavigationOptions {
  storageKey: string;
  transformReturnUrl?: (url: string) => string;
  getFallbackHref?: () => string | null;
}

export const useSessionStorageReturnNavigation = ({
  storageKey,
  transformReturnUrl,
  getFallbackHref,
}: UseSessionStorageReturnNavigationOptions) => {
  const navigate = useNavigate();

  return useCallback(() => {
    const storedReturnUrl = sessionStorage.getItem(storageKey);
    sessionStorage.removeItem(storageKey);
    if (storedReturnUrl && storedReturnUrl.startsWith("/") && !storedReturnUrl.startsWith("//")) {
      navigate(transformReturnUrl ? transformReturnUrl(storedReturnUrl) : storedReturnUrl);
      return;
    }

    const fallbackHref = getFallbackHref?.();
    if (fallbackHref) {
      navigate(fallbackHref);
      return;
    }

    navigate(-1);
  }, [getFallbackHref, navigate, storageKey, transformReturnUrl]);
};
